module.exports = __webpack_public_path__ + "static/media/Picture4-400x300x150.d2affbcb.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagenes/Picture4-400x300x150.png
// module id = 108
// module chunks = 0